export default __webpack_public_path__ + "static/media/gif.d614fe86.svg";